import Grid from '@mui/material/Grid2';
import CardInfo from './CardInfo';
import { InView } from 'react-intersection-observer';
import SkeletonCardInfo from './SkeletonCardInfo';

type Props = {
    data: any
    onCopy?: (data: any) => void
    dataSelected?: any
    onSelected?: (data: boolean) => void
    setDataSelected?: (data: any) => void
    status: boolean

    isPrivate: boolean // màn quản lý,
    onExtend?: (data: any) => void
    onStop?: (data: any) => void
    onFollow?: (data: any) => void
    onWithdraw?: (data: any) => void // rut tien
    onConfig?: (data: any) => void // config master
    onRegister?: () => void // register M or F
    onSellStuck?: () => void
    onSellOddLot?: () => void
}

export default function GridCardInfo({ data, onCopy, dataSelected, onSelected,
    setDataSelected, status, isPrivate, onExtend, onStop, onFollow,
    onWithdraw, onConfig, onRegister, onSellStuck, onSellOddLot,
}: Props) {
    const selected = data && data.find((item: any) => item.custodycd === dataSelected?.custodycd)
    return (
        <Grid
            container
            spacing={'20px'}
            justifyContent={'center'}
        // columns={{ xs: 2, sm: 8, md: 12, lg: 12, xl: 12 }}
        >
            {data.map((info: any, index: number) => (
                <Grid key={index}
                    size={"auto"}
                >
                    <InView triggerOnce rootMargin='100px'>
                        {({ ref, inView }) => (
                            <div ref={ref}>
                                {inView ? <CardInfo
                                    isPrivate={isPrivate}
                                    status={status}
                                    onSelected={onSelected}
                                    setDataSelected={setDataSelected}
                                    className={selected?.custodycd && info?.custodycd === selected?.custodycd ? 'selected' : ''}
                                    info={info}
                                    onCopy={onCopy}
                                    onExtend={onExtend}
                                    onStop={onStop}
                                    onFollow={onFollow}
                                    onWithdraw={onWithdraw}
                                    onConfig={onConfig}
                                    onRegister={onRegister}
                                    onSellStuck={onSellStuck}
                                    onSellOddLot={onSellOddLot}
                                /> : <SkeletonCardInfo key={index} />}
                            </div>
                        )}
                    </InView>
                </Grid>
            ))}
        </Grid>
    )
}